export const Name = 'analytics';
export const transformToAnalyticsEvent = event => {
  const detail = {
    originalEventType: event.type,
    originalEventDetail: event.detail
  };
  return new CustomEvent(Name, {
    detail
  });
};
export const forwardAnalyticsEvent = event => {
  const forwardedEvent = transformToAnalyticsEvent(event);
  window.dispatchEvent(forwardedEvent);
};
//# sourceMappingURL=index.js.map